export default __webpack_public_path__ + "static/media/lounge-banner1.b6289972.jpg";